export default __webpack_public_path__ + "traffic-signs-header-image-960-058b94a0f71d4a5810aba18d0b1b882d.png";